import { Realty, services } from '@ambita/ambita-components-core';

const util = services.util;

function transformCadastreConveyance(cadastreConveyanceData: Realty.ApiResponse) {
  if (cadastreConveyanceData.items && cadastreConveyanceData.items.length > 0) {
    const lastConveyance = cadastreConveyanceData.items[0];
    const retObject: any = util.pick(lastConveyance, [
      'dateRegistered',
      'purchasePrice',
      'conveyanceType',
      'documentCode',
      'appliesToEntireCadastre',
      'documentType'
    ]);

    retObject.multipleCadastres = lastConveyance.numberOfCadastresInConveyance
      && lastConveyance.numberOfCadastresInConveyance > 1;

    return {
      conveyance: retObject
    };
  }
}

export default transformCadastreConveyance;
